import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export const useCategoryGoalsQueryOptions = (startDate: string, endDate: string) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: ["categoryGoals", startDate, endDate],
    queryFn: async () => {
      return await apiClient.getCategoryGoals({
        queries: { start_date: startDate, end_date: endDate, market_place: marketPlace },
      });
    },
  });
};
